import { defineStore } from "pinia";
import { apiRequest } from '@/services/axios'

interface UserData {
    id: string;
    first_name: string;
    last_name: string;
}

const Auth = defineStore("auth", {
    state: () => ({
        isAuthenticated: false as boolean,
        userData: {} as UserData
    }),
    actions: {
        getToken() {
            return localStorage.getItem('authToken');
        },

        // Clear the token and remove it from localStorage
        invalidateAuth() {
            this.isAuthenticated = false;
            this.userData = {} as UserData;

            localStorage.removeItem("authToken");
        },

        // Verify token in backend
        async verifyToken() {
            try {
                const response = await apiRequest(
                    'post',
                    '/auth/verify-token',
                    {},
                    {
                        headers: {
                            Authorization: 'Bearer ' + localStorage.getItem('authToken')
                        }
                    }
                );

                if (response.data.success === true) {
                    // Populate user data from response
                    if (response.data.data) {
                        this.userData = response.data.data.data;
                    }
                    return true;
                } else {
                    this.invalidateAuth();

                    return false;
                }
            } catch {
                this.invalidateAuth();

                return false;
            }
        }
    },
    persist: true
});

export { Auth };
